const getAccessToken = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return authUser?.token || null;
  } catch (e) {
    return null;
  }
};

export default getAccessToken;
